var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMakerCarousel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.126465,
    width: 136.782,
    height: 136.782,
    rx: 27.3563,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.126465,
    width: 136.782,
    height: 136.782,
    rx: 27.3563,
    fill: "url(#paint0_linear_6356_10516)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6824 89.0001V56.6639L59.2048 75.1198V89.0001H65.4636V73.8167C65.4624 73.2525 65.3305 72.6963 65.0782 72.1916C64.8259 71.687 64.46 71.2477 64.0094 70.9083L34.2702 48.518C33.7262 48.114 33.0809 47.8687 32.4059 47.8095C31.731 47.7502 31.0528 47.8792 30.4467 48.1822C29.8407 48.4853 29.3305 48.9504 28.973 49.5259C28.6154 50.1015 28.4244 50.7649 28.4213 51.4425V89.0001H34.6824ZM102.501 89.0001V56.6639L77.979 75.1198V89.0001H71.7201V73.8167C71.7213 73.2525 71.8532 72.6963 72.1055 72.1916C72.3578 71.687 72.7237 71.2477 73.1743 70.9083L102.914 48.5272C103.457 48.1236 104.101 47.8784 104.776 47.8188C105.45 47.7591 106.127 47.8874 106.733 48.1893C107.339 48.4912 107.849 48.955 108.207 49.5292C108.565 50.1035 108.758 50.7657 108.762 51.4425V89.0001H102.501Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6356_10516",
    x1: 68.5173,
    y1: 0,
    x2: 68.5173,
    y2: 136.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FA89B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ACEBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakerCarousel);
export default __webpack_public_path__ + "static/media/maker-carousel.5b708afb1ec0b4b35dc806e6a7eac7d3.svg";
export { ForwardRef as ReactComponent };